"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.array.filter.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _take = _interopRequireDefault(require("lodash/take"));
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _activityIndicator = _interopRequireDefault(require("@gravity/activity-indicator"));
var _calendar = _interopRequireDefault(require("@gravity/calendar"));
var _filterBar = _interopRequireDefault(require("@gravity/filter-bar"));
var _product = require("@gravity/product");
var _section = require("@gravity/section");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _calendar2 = require("@nucleo/calendar");
var _filter = require("@nucleo/filter");
var _jsxFileName = "/codebuild/output/src3597011168/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/EventCalendar/lib/EventCalendar.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_mldamiise() {
  var path = "/codebuild/output/src3597011168/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/EventCalendar/lib/EventCalendar.js";
  var hash = "67256b50c634a875464b557b9a0f8d123864e4ef";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3597011168/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/EventCalendar/lib/EventCalendar.js",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 31,
          column: 2
        }
      },
      "1": {
        start: {
          line: 33,
          column: 30
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "2": {
        start: {
          line: 48,
          column: 59
        },
        end: {
          line: 48,
          column: 104
        }
      },
      "3": {
        start: {
          line: 60,
          column: 22
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "4": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 74,
          column: 39
        }
      },
      "5": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 83
        }
      },
      "6": {
        start: {
          line: 89,
          column: 23
        },
        end: {
          line: 94,
          column: 1
        }
      },
      "7": {
        start: {
          line: 96,
          column: 21
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "8": {
        start: {
          line: 100,
          column: 19
        },
        end: {
          line: 100,
          column: 31
        }
      },
      "9": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 144,
          column: 1
        }
      },
      "10": {
        start: {
          line: 105,
          column: 15
        },
        end: {
          line: 105,
          column: 17
        }
      },
      "11": {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 142,
          column: 3
        }
      },
      "12": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 141,
          column: 7
        }
      },
      "13": {
        start: {
          line: 108,
          column: 25
        },
        end: {
          line: 108,
          column: 53
        }
      },
      "14": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 135,
          column: 21
        }
      },
      "15": {
        start: {
          line: 112,
          column: 32
        },
        end: {
          line: 112,
          column: 89
        }
      },
      "16": {
        start: {
          line: 113,
          column: 29
        },
        end: {
          line: 113,
          column: 80
        }
      },
      "17": {
        start: {
          line: 114,
          column: 12
        },
        end: {
          line: 124,
          column: 14
        }
      },
      "18": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 140,
          column: 8
        }
      },
      "19": {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 139,
          column: 43
        }
      },
      "20": {
        start: {
          line: 143,
          column: 2
        },
        end: {
          line: 143,
          column: 14
        }
      },
      "21": {
        start: {
          line: 147,
          column: 29
        },
        end: {
          line: 182,
          column: 1
        }
      },
      "22": {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 180,
          column: 3
        }
      },
      "23": {
        start: {
          line: 149,
          column: 26
        },
        end: {
          line: 149,
          column: 88
        }
      },
      "24": {
        start: {
          line: 149,
          column: 59
        },
        end: {
          line: 149,
          column: 87
        }
      },
      "25": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 157,
          column: 5
        }
      },
      "26": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 156,
          column: 8
        }
      },
      "27": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "28": {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 163,
          column: 8
        }
      },
      "29": {
        start: {
          line: 165,
          column: 23
        },
        end: {
          line: 165,
          column: 90
        }
      },
      "30": {
        start: {
          line: 167,
          column: 20
        },
        end: {
          line: 167,
          column: 122
        }
      },
      "31": {
        start: {
          line: 168,
          column: 24
        },
        end: {
          line: 168,
          column: 83
        }
      },
      "32": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 179,
          column: 6
        }
      },
      "33": {
        start: {
          line: 181,
          column: 2
        },
        end: {
          line: 181,
          column: 14
        }
      },
      "34": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 17
        }
      },
      "35": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 195,
          column: 6
        }
      },
      "36": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 41
        }
      },
      "37": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 51
        }
      },
      "38": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 61
        }
      },
      "39": {
        start: {
          line: 202,
          column: 4
        },
        end: {
          line: 218,
          column: 5
        }
      },
      "40": {
        start: {
          line: 203,
          column: 20
        },
        end: {
          line: 203,
          column: 66
        }
      },
      "41": {
        start: {
          line: 204,
          column: 24
        },
        end: {
          line: 204,
          column: 32
        }
      },
      "42": {
        start: {
          line: 205,
          column: 23
        },
        end: {
          line: 205,
          column: 34
        }
      },
      "43": {
        start: {
          line: 206,
          column: 25
        },
        end: {
          line: 206,
          column: 86
        }
      },
      "44": {
        start: {
          line: 207,
          column: 6
        },
        end: {
          line: 211,
          column: 7
        }
      },
      "45": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 210,
          column: 11
        }
      },
      "46": {
        start: {
          line: 212,
          column: 24
        },
        end: {
          line: 212,
          column: 94
        }
      },
      "47": {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 217,
          column: 7
        }
      },
      "48": {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 216,
          column: 11
        }
      },
      "49": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 224,
          column: 5
        }
      },
      "50": {
        start: {
          line: 223,
          column: 6
        },
        end: {
          line: 223,
          column: 40
        }
      },
      "51": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 227,
          column: 7
        }
      },
      "52": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 233,
          column: 7
        }
      },
      "53": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 38
        }
      },
      "54": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "55": {
        start: {
          line: 244,
          column: 24
        },
        end: {
          line: 255,
          column: 3
        }
      },
      "56": {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 254,
          column: 6
        }
      },
      "57": {
        start: {
          line: 246,
          column: 20
        },
        end: {
          line: 252,
          column: 7
        }
      },
      "58": {
        start: {
          line: 253,
          column: 12
        },
        end: {
          line: 253,
          column: 50
        }
      },
      "59": {
        start: {
          line: 257,
          column: 23
        },
        end: {
          line: 265,
          column: 3
        }
      },
      "60": {
        start: {
          line: 258,
          column: 4
        },
        end: {
          line: 264,
          column: 6
        }
      },
      "61": {
        start: {
          line: 259,
          column: 20
        },
        end: {
          line: 262,
          column: 7
        }
      },
      "62": {
        start: {
          line: 263,
          column: 12
        },
        end: {
          line: 263,
          column: 48
        }
      },
      "63": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 272,
          column: 8
        }
      },
      "64": {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 280,
          column: 5
        }
      },
      "65": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 279,
          column: 8
        }
      },
      "66": {
        start: {
          line: 282,
          column: 63
        },
        end: {
          line: 282,
          column: 73
        }
      },
      "67": {
        start: {
          line: 284,
          column: 20
        },
        end: {
          line: 284,
          column: 24
        }
      },
      "68": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 297,
          column: 5
        }
      },
      "69": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 296,
          column: 8
        }
      },
      "70": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 315,
          column: 6
        }
      },
      "71": {
        start: {
          line: 319,
          column: 0
        },
        end: {
          line: 347,
          column: 2
        }
      },
      "72": {
        start: {
          line: 349,
          column: 0
        },
        end: {
          line: 363,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 48,
            column: 50
          },
          end: {
            line: 48,
            column: 51
          }
        },
        loc: {
          start: {
            line: 48,
            column: 59
          },
          end: {
            line: 48,
            column: 104
          }
        },
        line: 48
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 16
          }
        },
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 74,
            column: 39
          }
        },
        line: 70
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 83,
            column: 15
          },
          end: {
            line: 83,
            column: 16
          }
        },
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 83
          }
        },
        line: 84
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 104,
            column: 22
          },
          end: {
            line: 104,
            column: 23
          }
        },
        loc: {
          start: {
            line: 104,
            column: 74
          },
          end: {
            line: 144,
            column: 1
          }
        },
        line: 104
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 107,
            column: 29
          },
          end: {
            line: 107,
            column: 30
          }
        },
        loc: {
          start: {
            line: 107,
            column: 40
          },
          end: {
            line: 141,
            column: 5
          }
        },
        line: 107
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 111,
            column: 69
          },
          end: {
            line: 111,
            column: 70
          }
        },
        loc: {
          start: {
            line: 111,
            column: 77
          },
          end: {
            line: 125,
            column: 11
          }
        },
        line: 111
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 139,
            column: 17
          },
          end: {
            line: 139,
            column: 18
          }
        },
        loc: {
          start: {
            line: 139,
            column: 23
          },
          end: {
            line: 139,
            column: 43
          }
        },
        line: 139
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 147,
            column: 29
          },
          end: {
            line: 147,
            column: 30
          }
        },
        loc: {
          start: {
            line: 147,
            column: 73
          },
          end: {
            line: 182,
            column: 1
          }
        },
        line: 147
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 149,
            column: 48
          },
          end: {
            line: 149,
            column: 49
          }
        },
        loc: {
          start: {
            line: 149,
            column: 59
          },
          end: {
            line: 149,
            column: 87
          }
        },
        line: 149
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 189,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        loc: {
          start: {
            line: 189,
            column: 21
          },
          end: {
            line: 199,
            column: 3
          }
        },
        line: 189
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 3
          }
        },
        loc: {
          start: {
            line: 200,
            column: 30
          },
          end: {
            line: 219,
            column: 3
          }
        },
        line: 200
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 221,
            column: 2
          },
          end: {
            line: 221,
            column: 3
          }
        },
        loc: {
          start: {
            line: 221,
            column: 14
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 221
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 3
          }
        },
        loc: {
          start: {
            line: 230,
            column: 21
          },
          end: {
            line: 234,
            column: 3
          }
        },
        line: 230
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 236,
            column: 2
          },
          end: {
            line: 236,
            column: 3
          }
        },
        loc: {
          start: {
            line: 236,
            column: 25
          },
          end: {
            line: 242,
            column: 3
          }
        },
        line: 236
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 244,
            column: 24
          },
          end: {
            line: 244,
            column: 25
          }
        },
        loc: {
          start: {
            line: 244,
            column: 42
          },
          end: {
            line: 255,
            column: 3
          }
        },
        line: 244
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 246,
            column: 6
          },
          end: {
            line: 246,
            column: 7
          }
        },
        loc: {
          start: {
            line: 246,
            column: 20
          },
          end: {
            line: 252,
            column: 7
          }
        },
        line: 246
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 253,
            column: 7
          }
        },
        loc: {
          start: {
            line: 253,
            column: 12
          },
          end: {
            line: 253,
            column: 50
          }
        },
        line: 253
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 257,
            column: 23
          },
          end: {
            line: 257,
            column: 24
          }
        },
        loc: {
          start: {
            line: 257,
            column: 29
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 257
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 259,
            column: 6
          },
          end: {
            line: 259,
            column: 7
          }
        },
        loc: {
          start: {
            line: 259,
            column: 20
          },
          end: {
            line: 262,
            column: 7
          }
        },
        line: 259
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 263,
            column: 6
          },
          end: {
            line: 263,
            column: 7
          }
        },
        loc: {
          start: {
            line: 263,
            column: 12
          },
          end: {
            line: 263,
            column: 48
          }
        },
        line: 263
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        loc: {
          start: {
            line: 267,
            column: 11
          },
          end: {
            line: 316,
            column: 3
          }
        },
        line: 267
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 351,
            column: 2
          },
          end: {
            line: 351,
            column: 3
          }
        },
        loc: {
          start: {
            line: 351,
            column: 16
          },
          end: {
            line: 351,
            column: 18
          }
        },
        line: 351
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 352,
            column: 2
          },
          end: {
            line: 352,
            column: 3
          }
        },
        loc: {
          start: {
            line: 352,
            column: 22
          },
          end: {
            line: 352,
            column: 24
          }
        },
        line: 352
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 354,
            column: 2
          },
          end: {
            line: 354,
            column: 3
          }
        },
        loc: {
          start: {
            line: 354,
            column: 20
          },
          end: {
            line: 354,
            column: 22
          }
        },
        line: 354
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 355,
            column: 2
          },
          end: {
            line: 355,
            column: 3
          }
        },
        loc: {
          start: {
            line: 355,
            column: 18
          },
          end: {
            line: 355,
            column: 20
          }
        },
        line: 355
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 74,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 9
          },
          end: {
            line: 70,
            column: 14
          }
        }, {
          start: {
            line: 71,
            column: 10
          },
          end: {
            line: 71,
            column: 21
          }
        }, {
          start: {
            line: 72,
            column: 10
          },
          end: {
            line: 72,
            column: 35
          }
        }, {
          start: {
            line: 73,
            column: 10
          },
          end: {
            line: 73,
            column: 54
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 39
          }
        }],
        line: 70
      },
      "1": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 84,
            column: 48
          }
        }, {
          start: {
            line: 84,
            column: 52
          },
          end: {
            line: 84,
            column: 83
          }
        }],
        line: 84
      },
      "2": {
        loc: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 106
      },
      "3": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 13
          }
        }, {
          start: {
            line: 106,
            column: 17
          },
          end: {
            line: 106,
            column: 33
          }
        }],
        line: 106
      },
      "4": {
        loc: {
          start: {
            line: 111,
            column: 31
          },
          end: {
            line: 111,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 58
          },
          end: {
            line: 111,
            column: 59
          }
        }, {
          start: {
            line: 111,
            column: 62
          },
          end: {
            line: 111,
            column: 63
          }
        }],
        line: 111
      },
      "5": {
        loc: {
          start: {
            line: 112,
            column: 32
          },
          end: {
            line: 112,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 32
          },
          end: {
            line: 112,
            column: 57
          }
        }, {
          start: {
            line: 112,
            column: 61
          },
          end: {
            line: 112,
            column: 89
          }
        }],
        line: 112
      },
      "6": {
        loc: {
          start: {
            line: 113,
            column: 29
          },
          end: {
            line: 113,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 29
          },
          end: {
            line: 113,
            column: 51
          }
        }, {
          start: {
            line: 113,
            column: 55
          },
          end: {
            line: 113,
            column: 80
          }
        }],
        line: 113
      },
      "7": {
        loc: {
          start: {
            line: 116,
            column: 59
          },
          end: {
            line: 117,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 60
          },
          end: {
            line: 116,
            column: 71
          }
        }, {
          start: {
            line: 116,
            column: 75
          },
          end: {
            line: 116,
            column: 89
          }
        }, {
          start: {
            line: 117,
            column: 19
          },
          end: {
            line: 117,
            column: 27
          }
        }, {
          start: {
            line: 117,
            column: 31
          },
          end: {
            line: 117,
            column: 42
          }
        }],
        line: 116
      },
      "8": {
        loc: {
          start: {
            line: 126,
            column: 11
          },
          end: {
            line: 134,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 11
          },
          end: {
            line: 126,
            column: 22
          }
        }, {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 36
          }
        }, {
          start: {
            line: 128,
            column: 14
          },
          end: {
            line: 133,
            column: 30
          }
        }],
        line: 126
      },
      "9": {
        loc: {
          start: {
            line: 130,
            column: 25
          },
          end: {
            line: 130,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 130,
            column: 44
          },
          end: {
            line: 130,
            column: 72
          }
        }, {
          start: {
            line: 130,
            column: 75
          },
          end: {
            line: 130,
            column: 104
          }
        }],
        line: 130
      },
      "10": {
        loc: {
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 180,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 2
          },
          end: {
            line: 180,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 148
      },
      "11": {
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 13
          }
        }, {
          start: {
            line: 148,
            column: 17
          },
          end: {
            line: 148,
            column: 33
          }
        }],
        line: 148
      },
      "12": {
        loc: {
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 151
      },
      "13": {
        loc: {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 158
      },
      "14": {
        loc: {
          start: {
            line: 167,
            column: 30
          },
          end: {
            line: 167,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 49
          },
          end: {
            line: 167,
            column: 50
          }
        }, {
          start: {
            line: 167,
            column: 53
          },
          end: {
            line: 167,
            column: 54
          }
        }],
        line: 167
      },
      "15": {
        loc: {
          start: {
            line: 167,
            column: 95
          },
          end: {
            line: 167,
            column: 119
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 114
          },
          end: {
            line: 167,
            column: 115
          }
        }, {
          start: {
            line: 167,
            column: 118
          },
          end: {
            line: 167,
            column: 119
          }
        }],
        line: 167
      },
      "16": {
        loc: {
          start: {
            line: 194,
            column: 19
          },
          end: {
            line: 194,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 194,
            column: 39
          },
          end: {
            line: 194,
            column: 78
          }
        }, {
          start: {
            line: 194,
            column: 81
          },
          end: {
            line: 194,
            column: 90
          }
        }],
        line: 194
      },
      "17": {
        loc: {
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 202
      },
      "18": {
        loc: {
          start: {
            line: 202,
            column: 8
          },
          end: {
            line: 202,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 8
          },
          end: {
            line: 202,
            column: 27
          }
        }, {
          start: {
            line: 202,
            column: 31
          },
          end: {
            line: 202,
            column: 57
          }
        }],
        line: 202
      },
      "19": {
        loc: {
          start: {
            line: 207,
            column: 6
          },
          end: {
            line: 211,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 207,
            column: 6
          },
          end: {
            line: 211,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 207
      },
      "20": {
        loc: {
          start: {
            line: 213,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 213
      },
      "21": {
        loc: {
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 222,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 222
      },
      "22": {
        loc: {
          start: {
            line: 269,
            column: 6
          },
          end: {
            line: 272,
            column: 8
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 269,
            column: 7
          },
          end: {
            line: 269,
            column: 26
          }
        }, {
          start: {
            line: 270,
            column: 8
          },
          end: {
            line: 270,
            column: 42
          }
        }, {
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 79
          }
        }, {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 8
          }
        }],
        line: 269
      },
      "23": {
        loc: {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 280,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 280,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 274
      },
      "24": {
        loc: {
          start: {
            line: 285,
            column: 4
          },
          end: {
            line: 297,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 285,
            column: 4
          },
          end: {
            line: 297,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 285
      },
      "25": {
        loc: {
          start: {
            line: 285,
            column: 8
          },
          end: {
            line: 285,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 8
          },
          end: {
            line: 285,
            column: 14
          }
        }, {
          start: {
            line: 285,
            column: 19
          },
          end: {
            line: 285,
            column: 43
          }
        }, {
          start: {
            line: 285,
            column: 48
          },
          end: {
            line: 285,
            column: 66
          }
        }, {
          start: {
            line: 285,
            column: 70
          },
          end: {
            line: 285,
            column: 92
          }
        }],
        line: 285
      },
      "26": {
        loc: {
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 118
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 12
          },
          end: {
            line: 306,
            column: 34
          }
        }, {
          start: {
            line: 306,
            column: 38
          },
          end: {
            line: 306,
            column: 118
          }
        }],
        line: 306
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0, 0],
      "26": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "67256b50c634a875464b557b9a0f8d123864e4ef"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_mldamiise = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_mldamiise();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_mldamiise().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-EventCalendar'
}), (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    a.g-Button.g-Button-small {\n      margin: 0;\n    }\n  "]))))));
var ProductStickerWrapper = (cov_mldamiise().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-EventCalendar-ProductStickerWrapper'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      padding: ", " ", "\n        ", " ", ";\n    "])), _stylingConstants.default.spacing.xsmall, _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.xsmall, _stylingConstants.default.spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      padding: ", " 0\n        ", " 0;\n      > .stx-ProductSticker {\n        width: fit-content;\n        border: var(--dividerColor, #d5d5d9);\n        background-color: var(--itemRowBgColor, ", ");\n        margin: 0px 4px 0px 0px;\n        border-radius: var(--generalBorderRadius, 12px);\n        p.g-TextPreview {\n          color: var(--textColor);\n          padding: 0 8px;\n        }\n      }\n    "])), _stylingConstants.default.spacing.xsmall, _stylingConstants.default.spacing.xsmall, function (props) {
  cov_mldamiise().f[0]++;
  cov_mldamiise().s[2]++;
  return (0, _get.default)(props, 'theme.contentBgColor', '#ffffff');
}))));
var FooterWrapper = (cov_mldamiise().s[3]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-EventCalendar-FooterWrapper'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      padding: ", " ", " 0\n        ", ";\n\n      color: ", ";\n      text-align: right;\n      font-size: ", ";\n    "])), _stylingConstants.default.spacing.medium, _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.xxsmall, function (props) {
  cov_mldamiise().f[1]++;
  cov_mldamiise().s[4]++;
  return (cov_mldamiise().b[0][0]++, props) && (cov_mldamiise().b[0][1]++, props.theme) && (cov_mldamiise().b[0][2]++, props.theme.eventCalendar) && (cov_mldamiise().b[0][3]++, props.theme.eventCalendar.highlightTextColor) || (cov_mldamiise().b[0][4]++, _stylingConstants.default.color.baseText);
}, _stylingConstants.default.font.sizeMS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n      text-align: left;\n      padding: 2px 4px;\n\n      color: ", ";\n    "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, function (_ref) {
  var _theme$eventCalendar;
  var theme = _ref.theme;
  cov_mldamiise().f[2]++;
  cov_mldamiise().s[5]++;
  return (cov_mldamiise().b[1][0]++, theme === null || theme === void 0 || (_theme$eventCalendar = theme.eventCalendar) === null || _theme$eventCalendar === void 0 ? void 0 : _theme$eventCalendar.highlightTextColor) || (cov_mldamiise().b[1][1]++, _stylingConstants.default.color.baseText);
}))));
var LoadingWrapper = (cov_mldamiise().s[6]++, _styledComponents.default.div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  text-align: center;\n  padding: ", ";\n  min-height: ", ";\n"])), _stylingConstants.default.spacing.medium, _stylingConstants.default.spacing.xxlarge));
var MonthDetails = (cov_mldamiise().s[7]++, _styledComponents.default.span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  width: 0px;\n"]))));
var DayContent = (cov_mldamiise().s[8]++, _styledComponents.default.div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)([""]))));

// This function generate the object needed by the calendar to display the events
// the content is a sticker, the indicator show the number of events contains for a specific day.
cov_mldamiise().s[9]++;
var sectionToDays = function sectionToDays(section, setDay, selectedDay, isEvolutionTheme) {
  cov_mldamiise().f[3]++;
  var days = (cov_mldamiise().s[10]++, {});
  cov_mldamiise().s[11]++;
  if ((cov_mldamiise().b[3][0]++, section) && (cov_mldamiise().b[3][1]++, section.clusters)) {
    cov_mldamiise().b[2][0]++;
    cov_mldamiise().s[12]++;
    section.clusters.forEach(function (cluster) {
      cov_mldamiise().f[4]++;
      var isSelected = (cov_mldamiise().s[13]++, selectedDay === cluster.name);
      var content = (cov_mldamiise().s[14]++, /*#__PURE__*/_react.default.createElement(DayContent, {
        role: "button",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 9
        }
      }, (0, _take.default)(cluster.items, cluster.items.length > 3 ? (cov_mldamiise().b[4][0]++, 2) : (cov_mldamiise().b[4][1]++, 3)).map(function (item) {
        cov_mldamiise().f[5]++;
        var performance = (cov_mldamiise().s[15]++, (cov_mldamiise().b[5][0]++, item.product.performances) && (cov_mldamiise().b[5][1]++, item.product.performances[0]));
        var timeslot = (cov_mldamiise().s[16]++, (cov_mldamiise().b[6][0]++, item.product.timeslots) && (cov_mldamiise().b[6][1]++, item.product.timeslots[0]));
        cov_mldamiise().s[17]++;
        return /*#__PURE__*/_react.default.createElement(ProductStickerWrapper, {
          key: "".concat(cluster.name, "-").concat(item.product.id, "-").concat((cov_mldamiise().b[7][0]++, performance) && (cov_mldamiise().b[7][1]++, performance.id) || (cov_mldamiise().b[7][2]++, timeslot) && (cov_mldamiise().b[7][3]++, timeslot.id)),
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 115,
            columnNumber: 15
          }
        }, /*#__PURE__*/_react.default.createElement(_product.ProductSticker, {
          product: item.product,
          performance: performance,
          timeslot: timeslot,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 118,
            columnNumber: 17
          }
        }));
      }), (cov_mldamiise().b[8][0]++, !isSelected) && (cov_mldamiise().b[8][1]++, cluster.items.length > 3) && (cov_mldamiise().b[8][2]++, /*#__PURE__*/_react.default.createElement(FooterWrapper, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "".concat(isEvolutionTheme ? (cov_mldamiise().b[9][0]++, 'gravity.EventCalendar.more') : (cov_mldamiise().b[9][1]++, 'gravity.EventCalendar.other')),
        values: {
          otherQuantity: cluster.items.length - 2
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 17
        }
      })))));
      cov_mldamiise().s[18]++;
      days[cluster.name] = {
        content: content,
        onClick: function onClick() {
          cov_mldamiise().f[6]++;
          cov_mldamiise().s[19]++;
          return setDay(cluster.name);
        }
      };
    });
  } else {
    cov_mldamiise().b[2][1]++;
  }
  cov_mldamiise().s[20]++;
  return days;
};

// get a section definition with only one cluster corresponding to the selected date
cov_mldamiise().s[21]++;
var getDetaileDayContent = function getDetaileDayContent(section, detailedDay, isEvolutionTheme) {
  cov_mldamiise().f[7]++;
  cov_mldamiise().s[22]++;
  if ((cov_mldamiise().b[11][0]++, section) && (cov_mldamiise().b[11][1]++, section.clusters)) {
    cov_mldamiise().b[10][0]++;
    var curDayCluster = (cov_mldamiise().s[23]++, section.clusters.find(function (cluster) {
      cov_mldamiise().f[8]++;
      cov_mldamiise().s[24]++;
      return cluster.name === detailedDay;
    }));
    cov_mldamiise().s[25]++;
    if (!curDayCluster) {
      cov_mldamiise().b[12][0]++;
      cov_mldamiise().s[26]++;
      return /*#__PURE__*/_react.default.createElement("span", {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 153,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.ProductList.notFound",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 11
        }
      }));
    } else {
      cov_mldamiise().b[12][1]++;
    }
    cov_mldamiise().s[27]++;
    if (curDayCluster.LOADING) {
      cov_mldamiise().b[13][0]++;
      cov_mldamiise().s[28]++;
      return /*#__PURE__*/_react.default.createElement(LoadingWrapper, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161,
          columnNumber: 11
        }
      }));
    } else {
      cov_mldamiise().b[13][1]++;
    }
    var daySection = (cov_mldamiise().s[29]++, (0, _assign.default)({}, section, {
      clusters: [curDayCluster],
      name: ''
    }));
    // adapt the number of columns and the aspectratio to the number of items.
    var nbOfCol = (cov_mldamiise().s[30]++, Math.max(isEvolutionTheme ? (cov_mldamiise().b[14][0]++, 5) : (cov_mldamiise().b[14][1]++, 2), Math.min(curDayCluster.items.length, isEvolutionTheme ? (cov_mldamiise().b[15][0]++, 5) : (cov_mldamiise().b[15][1]++, 6))));
    var aspectRatio = (cov_mldamiise().s[31]++, ['LANDSCAPE', 'WIDE', 'SQUARE'][Math.ceil(nbOfCol / 2) - 1]);
    // show 7 columns to be aligned with days
    cov_mldamiise().s[32]++;
    return /*#__PURE__*/_react.default.createElement(_section.Section, {
      section: daySection,
      columns: nbOfCol,
      randomOrder: false,
      aspectRatio: aspectRatio,
      showDate: false,
      showTime: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 171,
        columnNumber: 7
      }
    });
  } else {
    cov_mldamiise().b[10][1]++;
  }
  cov_mldamiise().s[33]++;
  return null;
};

/**
 * The Event calendar take a section with clusters by day. In a month calendar
 * it shows the events we have
 */
var EventCalendar = /*#__PURE__*/function (_React$PureComponent) {
  function EventCalendar(props) {
    var _this2;
    (0, _classCallCheck2.default)(this, EventCalendar);
    cov_mldamiise().f[9]++;
    cov_mldamiise().s[34]++;
    _this2 = _callSuper(this, EventCalendar, [props]);
    (0, _defineProperty2.default)(_this2, "handleFilterChanged", (cov_mldamiise().s[55]++, function (filterCriteria) {
      cov_mldamiise().f[14]++;
      cov_mldamiise().s[56]++;
      _this2.setState(function (prevState) {
        cov_mldamiise().f[15]++;
        cov_mldamiise().s[57]++;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          filterCriteria: _objectSpread(_objectSpread({}, prevState.filterCriteria), filterCriteria)
        });
      }, function () {
        cov_mldamiise().f[16]++;
        cov_mldamiise().s[58]++;
        return _this2.props.onFilterApplied(_this2.state);
      });
    }));
    (0, _defineProperty2.default)(_this2, "handledFilterReset", (cov_mldamiise().s[59]++, function () {
      cov_mldamiise().f[17]++;
      cov_mldamiise().s[60]++;
      _this2.setState(function (prevState) {
        cov_mldamiise().f[18]++;
        cov_mldamiise().s[61]++;
        return _objectSpread(_objectSpread({}, prevState), {}, {
          filterCriteria: {}
        });
      }, function () {
        cov_mldamiise().f[19]++;
        cov_mldamiise().s[62]++;
        return _this2.props.onFilterReset(_this2.state);
      });
    }));
    cov_mldamiise().s[35]++;
    _this2.state = {
      filterCriteria: props.filterCriteria,
      month: props.month,
      detailedDay: props.detailedDay ? (cov_mldamiise().b[16][0]++, (0, _format.default)(props.detailedDay, 'YYYY-MM-DD')) : (cov_mldamiise().b[16][1]++, undefined)
    };
    cov_mldamiise().s[36]++;
    _this2.setDay = _this2.setDay.bind(_this2);
    cov_mldamiise().s[37]++;
    _this2.changeMonth = _this2.changeMonth.bind(_this2);
    cov_mldamiise().s[38]++;
    _this2.closeDetailedDay = _this2.closeDetailedDay.bind(_this2);
    return _this2;
  }
  (0, _inherits2.default)(EventCalendar, _React$PureComponent);
  return (0, _createClass2.default)(EventCalendar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      cov_mldamiise().f[10]++;
      cov_mldamiise().s[39]++;
      // check if the date is in the rage and change if needed.
      if ((cov_mldamiise().b[18][0]++, this.props.calendar) && (cov_mldamiise().b[18][1]++, this.props.calendar.months)) {
        cov_mldamiise().b[17][0]++;
        var years = (cov_mldamiise().s[40]++, (0, _keys.default)(this.props.calendar.months).sort());
        var firstYear = (cov_mldamiise().s[41]++, years[0]);
        var lastYear = (cov_mldamiise().s[42]++, years.pop());
        var firstMonth = (cov_mldamiise().s[43]++, new Date(firstYear, this.props.calendar.months[firstYear][0]));
        cov_mldamiise().s[44]++;
        if ((0, _is_before.default)(this.state.month, firstMonth)) {
          cov_mldamiise().b[19][0]++;
          cov_mldamiise().s[45]++;
          this.setState({
            month: firstMonth
          });
        } else {
          cov_mldamiise().b[19][1]++;
        }
        var lastMonth = (cov_mldamiise().s[46]++, new Date(lastYear, this.props.calendar.months[firstYear].slice(-1)[0]));
        cov_mldamiise().s[47]++;
        if ((0, _is_before.default)(lastMonth, this.state.month)) {
          cov_mldamiise().b[20][0]++;
          cov_mldamiise().s[48]++;
          this.setState({
            month: lastMonth
          });
        } else {
          cov_mldamiise().b[20][1]++;
        }
      } else {
        cov_mldamiise().b[17][1]++;
      }
    }
  }, {
    key: "setDay",
    value: function setDay(day) {
      cov_mldamiise().f[11]++;
      cov_mldamiise().s[49]++;
      if (day) {
        cov_mldamiise().b[21][0]++;
        cov_mldamiise().s[50]++;
        this.props.changeDetailedDay(day);
      } else {
        cov_mldamiise().b[21][1]++;
      }
      cov_mldamiise().s[51]++;
      this.setState({
        detailedDay: day
      });
    }
  }, {
    key: "closeDetailedDay",
    value: function closeDetailedDay() {
      cov_mldamiise().f[12]++;
      cov_mldamiise().s[52]++;
      this.setState({
        detailedDay: null
      });
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(monthDate) {
      cov_mldamiise().f[13]++;
      cov_mldamiise().s[53]++;
      this.props.changeMonth(monthDate);
      cov_mldamiise().s[54]++;
      this.setState({
        month: monthDate,
        detailedDay: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_mldamiise().f[20]++;
      var curSection = (cov_mldamiise().s[63]++, (cov_mldamiise().b[22][0]++, this.props.calendar) && (cov_mldamiise().b[22][1]++, this.props.calendar.sectionByMonth) && (cov_mldamiise().b[22][2]++, this.props.calendar.sectionByMonth[(0, _format.default)(this.state.month, 'YYYY-MM')]) || (cov_mldamiise().b[22][3]++, {}));
      var monthDetails;
      cov_mldamiise().s[64]++;
      if (this.props.calendar.LOADING) {
        cov_mldamiise().b[23][0]++;
        cov_mldamiise().s[65]++;
        monthDetails = /*#__PURE__*/_react.default.createElement(MonthDetails, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 276,
            columnNumber: 9
          }
        }, /*#__PURE__*/_react.default.createElement(_activityIndicator.default, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 277,
            columnNumber: 11
          }
        }));
      } else {
        cov_mldamiise().b[23][1]++;
      }
      var _ref2 = (cov_mldamiise().s[66]++, this.props),
        filter = _ref2.filter,
        arrFilters = _ref2.arrFilters,
        currencyCode = _ref2.currencyCode,
        themeQueries = _ref2.themeQueries;
      var filterBar = (cov_mldamiise().s[67]++, null);
      cov_mldamiise().s[68]++;
      if ((cov_mldamiise().b[25][0]++, filter) && ((cov_mldamiise().b[25][1]++, themeQueries.EQUILIBRIUM) || (cov_mldamiise().b[25][2]++, arrFilters !== null && arrFilters !== void 0 && arrFilters.length) && (cov_mldamiise().b[25][3]++, (arrFilters === null || arrFilters === void 0 ? void 0 : arrFilters.length) > 0))) {
        cov_mldamiise().b[24][0]++;
        cov_mldamiise().s[69]++;
        filterBar = /*#__PURE__*/_react.default.createElement(_filterBar.default, {
          filter: filter,
          onFilterChanged: this.handleFilterChanged,
          onFilterReset: this.handledFilterReset,
          currencyCode: currencyCode,
          arrFilters: arrFilters,
          filterCriteria: filter.filterCriteria,
          showPastDates: this.props.showPastDatesOnFilter,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 287,
            columnNumber: 9
          }
        });
      } else {
        cov_mldamiise().b[24][1]++;
      }
      cov_mldamiise().s[70]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 300,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_calendar.default, {
        days: sectionToDays(curSection, this.setDay, this.state.detailedDay, themeQueries.EVOLUTION),
        month: this.state.month,
        detailedDay: this.state.detailedDay,
        detailedDayContent: (cov_mldamiise().b[26][0]++, this.state.detailedDay) && (cov_mldamiise().b[26][1]++, getDetaileDayContent(curSection, this.state.detailedDay, themeQueries.EVOLUTION)),
        onMonthChange: this.changeMonth,
        months: this.props.calendar.months,
        closeDetailedDay: this.closeDetailedDay,
        monthDetails: monthDetails,
        additionalChild: filterBar,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 301,
          columnNumber: 9
        }
      }));
    }
  }]);
}((_react.default.PureComponent));
cov_mldamiise().s[71]++;
EventCalendar.propTypes = {
  /* The product list by dates */
  calendar: _calendar2.CalendarType.isRequired,
  /** The base day we use to get the initial month */
  month: _propTypes.default.instanceOf(Date),
  /** The selected day for which we want to have more details */
  detailedDay: _propTypes.default.instanceOf(Date),
  /** Action to call when the monthChange */
  changeMonth: _propTypes.default.func,
  /** Action to call when the detailed day changed */
  changeDetailedDay: _propTypes.default.func,
  /* The needed currency to display prices */
  currencyCode: _propTypes.default.string.isRequired,
  /** The function called when filter criteria have changed */
  onFilterApplied: _propTypes.default.func.isRequired,
  /** The function called when filter has been reset */
  onFilterReset: _propTypes.default.func.isRequired,
  /** True if we want to display past dates in the date filter  */
  showPastDatesOnFilter: _propTypes.default.bool,
  /** the filter data */
  filter: _propTypes.default.shape(_filter.FilterType),
  /** The list of supported filters must be displayed */
  arrFilters: _propTypes.default.arrayOf(_propTypes.default.string),
  /** The list of filter criterias */
  filterCriteria: _filter.FilterType,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_mldamiise().s[72]++;
EventCalendar.defaultProps = {
  month: new Date(),
  changeMonth: function changeMonth() {
    cov_mldamiise().f[21]++;
  },
  changeDetailedDay: function changeDetailedDay() {
    cov_mldamiise().f[22]++;
  },
  detailedDay: undefined,
  onFilterApplied: function onFilterApplied() {
    cov_mldamiise().f[23]++;
  },
  onFilterReset: function onFilterReset() {
    cov_mldamiise().f[24]++;
  },
  filterCriteria: {},
  filter: {},
  arrFilters: [],
  showPastDatesOnFilter: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(EventCalendar));